import { application } from "./application"
import AttachmentController from "./attachment_controller"
import ShowPasswordController from "./show_password_controller"

application.register("attachment", AttachmentController)
application.register("show-password", ShowPasswordController)
